import "../api/axiosConfig.ts";
import { RouteConfig, renderRoutes } from "react-router-config";
// Import your global styles here
import "normalize.css/normalize.css";
import styles from "./app.module.scss";
import { DesktopLayout } from "./Layout";
import UserDataLayout from "./components/UserDataLayout";
import DataLayout from "./components/DataLayout";

interface Route {
  route: { routes: RouteConfig[] };
}

const DesktopApp = ({ route }: Route): JSX.Element => (
  <div className={styles.App} suppressHydrationWarning>
    <DataLayout routes={route.routes} />
    <UserDataLayout routes={route.routes} />
    <DesktopLayout>{renderRoutes(route.routes)}</DesktopLayout>
  </div>
);

export default DesktopApp;
